import{k as t}from"./chunk-ZUXEYBK5.js";import{a as r}from"./chunk-BJLACGZ2.js";import{m as e}from"./chunk-HBP5N4FR.js";e();function f(){return t(r.getState())}export{f as a};
//# sourceMappingURL=chunk-Q2MHKB63.js.map
